/** La scheda Risorse: grafici, live, log della finestra e avvisi dello stack. */
export const risorse = {
  "risorse.graficoCpu": "CPU %",
  "risorse.graficoMemoria": "Memoria (% del limite)",
  "risorse.graficoRete": "Rete (KB/s)",
  "risorse.rapida.1h": "1h",
  "risorse.rapida.6h": "6h",
  "risorse.rapida.24h": "24h",
  "risorse.rapida.7g": "7g",
  "risorse.liveAiuto": "Un dato ogni 2 secondi, per 5 minuti al massimo",
  "risorse.inizio": "Inizio della finestra",
  "risorse.fine": "Fine della finestra",
  "risorse.liveTerminato": "Live terminato.",
  "risorse.attesaDati": "In attesa dei primi dati…",
  "risorse.nessunDato": "Nessun dato in questa finestra",
  "risorse.servonoContainer": "Lo stack deve avere container avviati.",
  "risorse.ogni15": "I consumi si registrano ogni 15 secondi mentre lo stack è avviato.",
  "risorse.graficiAiuto":
    "Trascina su un grafico per restringere la finestra; clic su una linea o una riga per seguire un servizio.",
  "risorse.servizio": "Servizio",
  "risorse.cpuOra": "CPU ora",
  "risorse.cpuPicco": "CPU picco",
  "risorse.memOra": "Mem ora",
  "risorse.memPicco": "Mem picco",
  "risorse.reteOra": "Rete ora",
  "risorse.retePicco": "Rete picco",
  "risorse.eventi": "Eventi",
  "risorse.nessunLog": "Nessuna riga di log in questa finestra.",
  "risorse.sogliaCpu": "CPU %",
  "risorse.perMinuti": "per minuti",
  "risorse.sogliaMemoria": "Memoria %",
  "risorse.avvisi": "Avvisi per questo stack",
  "risorse.inviaAvvisi": "Invia avvisi per questo stack",
  "risorse.campoVuoto": "Un campo vuoto usa la soglia globale delle Impostazioni.",
};
